module.exports = __webpack_public_path__ + "img/DE00319.e6558356.png";